var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-wrapper apcn" }, [
    _c(
      "div",
      { staticClass: "login-box" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showRetry,
                expression: "!showRetry",
              },
            ],
            staticClass: "row cam-wrap",
          },
          [
            _c("div", { staticClass: "col body m-0" }, [
              _c("h4", [_vm._v(_vm._s(_vm.$t("login.title")))]),
              _vm._v(" "),
              _c("div", { staticClass: "cam-inner" }, [
                _c("div", { ref: "face_fail", staticClass: "item limited" }, [
                  _c(
                    "div",
                    { staticClass: "inner" },
                    [
                      _c("i", { staticClass: "icon icon-issue_1" }),
                      _vm._v(" "),
                      _c("p", [
                        _vm.examStatus.state === "exam_end"
                          ? _c("strong", [
                              _vm._v(
                                _vm._s(_vm.$t("userStateMessage.examEnd")) + "."
                              ),
                            ])
                          : _vm.failStatus
                          ? _c(
                              "strong",
                              [
                                _c("i18n", {
                                  attrs: { path: "error.adminNotFound" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "br",
                                      fn: function () {
                                        return [_c("br")]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                }),
                              ],
                              1
                            )
                          : _c("strong", [
                              _vm._v(_vm._s(_vm.$t("login.limit.row1"))),
                            ]),
                      ]),
                      _vm._v(" "),
                      _c("i18n", {
                        attrs: { tag: "p", path: "login.limit.row2" },
                        scopedSlots: _vm._u([
                          {
                            key: "inquiry",
                            fn: function () {
                              return [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.inquiryLink,
                                      target: _vm.inquiryTarget,
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.examInfo.contactLink))]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "br",
                            fn: function () {
                              return [_c("br")]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "item cam-box" },
                  [
                    _c("div", {
                      staticClass: "loading",
                      staticStyle: { display: "none" },
                      attrs: { id: "regist_face_loading" },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "video-box" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("canvas", {
                        ref: "canvasOutput",
                        staticClass: "item output",
                        style: _vm.drawRectangle
                          ? {
                              width: "100%",
                              height: "100%",
                              zIndex: 1000,
                            }
                          : { display: "none" },
                      }),
                      _vm._v(" "),
                      _c(
                        "video",
                        {
                          ref: "face_video",
                          attrs: { autoplay: "", playsinline: "", muted: "" },
                          domProps: { muted: true },
                          on: { play: _vm.onPlayVideo },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("login.notSupportVideoTag")) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("i18n", {
                      staticClass: "text-guide",
                      attrs: { tag: "p", path: _vm.guideMessage },
                      scopedSlots: _vm._u([
                        {
                          key: "br",
                          fn: function () {
                            return [_c("br")]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("RetryLoginGuide", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showRetry,
              expression: "showRetry",
            },
          ],
          attrs: {
            userId: _vm.userId,
            companyId: this.examInfo.companyId,
            contractLink: _vm.inquiryLink,
            contractLinkText: _vm.examInfo.contactLink,
            contractTarget: _vm.inquiryTarget,
            loginFailAction: _vm.examInfo.loginFailAction,
          },
          on: { retryLogin: _vm.retryLogin },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item guide-line" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/login/face_outline_640.png"),
          alt: "얼굴위치 가이드라인",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }